import React, { useEffect, useState, useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../../components/comman/Sidebar";
import ProjectFilter from "../model/ProjectFilter";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Checkbox,
  Grid,
  InputAdornment,
  ListItemText,
  Stack,
  Button,
  TableSortLabel,
  PaginationItem,
  Icon,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { GET_ALL_PROJECT_FILTER_URL } from "../../constants/ApiRoute";
import { authHeader } from "../comman/MainFunction";
import API from "../comman/API";

import Pagination from "@mui/material/Pagination";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { Link } from "react-router-dom";
import { ADD_PROJECT } from "../../constants/RoutePath";
import UserClearFilter from "../model/UserClearFilter";
import CustomPageLoading from "../comman/CustomPageLoading";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomersList, getAllProjectsList } from "../../redux/action";
import Navbar from "../comman/Navbar";
import { useToast } from "../comman/CustomMessages";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";

//import Checkbox from '@mui/material/Checkbox';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import NoRecordFound from "../comman/NoRecordFound";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { PAGE_OFFSET, SORT_PARAMS } from "../../redux/action/ActionType";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, projectName, theme) {
  return {
    fontWeight:
      projectName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const filterInitial = {
  active: "",
  customerActive: "",
  noOfLocation: "",
  noOfBroker: "",
  billingPeriod: "",
  projectId: "",
  customerId: "",
};

const Projectindex = () => {
  const currentPage = useSelector((r) => r.PageReducer);
  const currentSort = useSelector((r) => r.SortReducer);
  console.log("currentPage", currentPage)
  console.log("currentSort", currentSort)
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const showToast = useToast();
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState(10);
  const theme = useTheme();
  const [projectName, setProjectName] = React.useState([]);
  const [projectNameList, setProjectNameList] = React.useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [filter, setFilter] = React.useState(filterInitial);
  const [clearFlag, setClearFlag] = useState(false);
  const [clearFiltervalue, setClearFilterValue] = useState(false);
  const [search, setSearch] = React.useState("");
  const [applyFilterFlag, setApplyFilterFlag] = React.useState(false);
  const [orderBy, setOrderBy] = useState("Name");
  const [order, setOrder] = useState("asc");
  const [sortClickedTime, setSortClickedTime] = useState("");
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [backButtonFilter, setBackButtonFilter] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const dispatch = useDispatch();
  const projectListSel = deCryptFun(
    useSelector((s) => s.AllProjectListReducer)
  );
  const projectList = projectListSel ? JSON.parse(projectListSel).data : [];

  const findDuplicateProjectId = (array) => {
    let seen = new Set();
    let duplicates = new Set();

    array.forEach((obj) => {
      if (seen.has(obj.ProjectId)) {
        duplicates.add(obj.ProjectId);
      } else {
        seen.add(obj.ProjectId);
      }
    });

    return Array.from(duplicates);
  };

  useEffect(() => {
    if (isInitialLoad) {
      dispatch({
        type: PAGE_OFFSET,
        payload: 0,
      });
      setIsInitialLoad(false);
    }
  }, [isInitialLoad, dispatch]);

  const handleSearchOnChange = (event, newValue) => {
    if (event.target.type != "text") {
      const duplicateArray = findDuplicateProjectId(newValue);
      if (duplicateArray && duplicateArray.length > 0) {
        const updatedNewArray = newValue.filter(
          (obj) => obj.ProjectId !== duplicateArray[0]
        );
        newValue = updatedNewArray;
      }

      const uniqueSelectedProjects = newValue.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.ProjectId === item.ProjectId)
      );
      setSelectedProjects(uniqueSelectedProjects);

      dispatch({
        type: PAGE_OFFSET,
        payload: 0,
      });
      setPage(0)

      if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
        const idsString = uniqueSelectedProjects
          .map((item) => item.ProjectId)
          .join(",");
          setSearch(idsString)
        getProjectFilterList(idsString,0);
      } else {
        setSearch("")
        getProjectFilterList("empty");
      }
    }
  };

  const handleSearchDeleteOnChange = (value) => {
    var arr = selectedProjects.filter((item) => item.ProjectId !== value);
    var uniqueSelectedProjects = arr;
    setSelectedProjects(arr);

    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });
    setPage(0)

    if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
      const idsString = uniqueSelectedProjects
        .map((item) => item.ProjectId)
        .join(",");
      setSearch(idsString)
      getProjectFilterList(idsString,0);
    } else {
      setSearch("")
      getProjectFilterList("empty");
    }
  };

  const handleSearchCheckboxOnChange = (value, isSelected) => {
    let uniqueSelectedProjects = "";
    if (isSelected) {
      var arr = selectedProjects.filter(
        (item) => item.ProjectId !== value.ProjectId
      );
      uniqueSelectedProjects = arr;
      setSelectedProjects(arr);
    } else {
      const updatedProjects = [...selectedProjects, value];
      setSelectedProjects(updatedProjects);
      uniqueSelectedProjects = updatedProjects;
    }

    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });
    setPage(0)

    if (uniqueSelectedProjects && uniqueSelectedProjects.length > 0) {
      const idsString = uniqueSelectedProjects
        .map((item) => item.ProjectId)
        .join(",");
      setSearch(idsString)
      getProjectFilterList(idsString,0);
    } else {
      setSearch("")
      getProjectFilterList("empty");
    }
  };

  // const getProjectList = async (pageNumber) => {

  //   console.log("ON PAGE LOAD 2")

  //   let data = {
  //     count: count,
  //     offset: page ? page : 0,
  //     sort: "",
  //     orderBy: "",
  //   };

  //   if (typeof pageNumber === "number") {
  //     data.offset = pageNumber;
  //   }

  //   if (order) {
  //     data.sort = order;
  //     data.orderBy = orderBy;
  //   }

  //   // if (customerId && customerId.length > 0) {
  //   //   data.customerId = customerId.join(",");
  //   // }

  //   // if (projectId && projectId.length > 0) {
  //   //   data.projectId = projectId.join(",");
  //   // }
  //   // data.customerActive = customerActive;
  //   // data.active = active;

  //   // if (search) {
  //   //   data.projectId = search;
  //   // }

  //   // if (billingPeriod) {
  //   //   data.billingPeriod = billingPeriod;
  //   // }
  //   // if (noOfBroker) {
  //   //   data.noOfBroker = noOfBroker;
  //   // }
  //   // if (noOfLocation) {
  //   //   data.noOfLocation = noOfLocation;
  //   // }

  //   const config = {
  //     method: "GET",
  //     url: GET_ALL_PROJECT_FILTER_URL,
  //     headers: authHeader(),
  //     params: {
  //       webString: enCryptFun(JSON.stringify(data)),
  //       flutterString: "",
  //     },
  //   };
  //   try {
  //     setLoading(true);
  //     const response = await API(config);
  //     let decryptedResponse = await deCryptFun(response.data);
  //     const parsedResponse = JSON.parse(decryptedResponse);
  //     console.log("parsedResponse", parsedResponse);
  //     if (parsedResponse.status === "Success") {
  //       setList(parsedResponse.data);
  //       setTotal(Math.ceil(parsedResponse.totalCount / count));
  //     }
  //   } catch (error) {
  //     if (error.response) {
  //       let { data } = error.response;
  //       let p = deCryptFun(data);
  //       let v = JSON.parse(p);
  //       showToast(v.message, "error");
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const formatNumber = (number) => {
    if (number) {
      return number.toString().padStart(2, "0");
    } else {
      return 0;
    }
  };
  const getProjectFilterList = async (searchInput, pageNumber) => {
if(order=='asc'){
  dispatch({
    type: SORT_PARAMS,
    payload: { order: order, orderBy: orderBy },
  });

}
    console.log("ON PAGE LOAD 1", searchInput)
    const {
      active,
      customerActive,
      noOfLocation,
      noOfBroker,
      billingPeriod,
      projectId,
      customerId,
    } = filter;


    var noOfBrokerParse =  parseInt(noOfBroker);
    var billingPeriodParse =  parseInt(billingPeriod);
    var noOfLocationParse =  parseInt(noOfLocation);

    // console.log("type of noOfBroker", typeof noOfBrokerParse, noOfBrokerParse)
    
    let data = {
      count: count,
      offset: currentPage ? currentPage : 0,
      sort: "",
      orderBy: "",
    };

    if(typeof pageNumber == "number"){
      data.offset = pageNumber;
    }

    if (customerId && customerId.length > 0) {
      data.customerId = customerId.join(",");
    }

    if (projectId && projectId.length > 0) {
      data.projectId = projectId.join(",");
    }
    //data.customerActive = customerActive;

    if (typeof active == "boolean") {
      data.active = active ? 1 : 0;
    }

    if (typeof customerActive == "boolean") {
      data.customerActive = customerActive ? 1 : 0;
    }

    // data.active = active;

    if (selectedProjects && selectedProjects.length > 0) {
      const idsString = selectedProjects.map((item) => item.ProjectId).join(",");
      data.projectId = idsString;
    }

    if (search) {
      data.projectId = search;
    }

    if (searchInput) {
      data.projectId = searchInput;
    }

    if (searchInput && searchInput == "empty") {
      data.projectId = "";
    }

    if (typeof billingPeriodParse == "number") {
      data.billingPeriod = billingPeriodParse;
    }
    if (typeof noOfBrokerParse == "number") {
      data.brokerCount = noOfBrokerParse;
    }
    if (typeof noOfLocationParse == "number") {
      data.noOfLocation = noOfLocationParse;
    }

    if (order) {
      data.sort = order;
      data.orderBy = orderBy;
    }

    const config = {
      method: "GET",
      url: GET_ALL_PROJECT_FILTER_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
        flutterString: "",
      },
    };

    try {
      setLoading(true);
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status == "Success") {
        setList(parsedResponse.data);
        setTotal(Math.ceil(parsedResponse.totalCount / count));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSortRequest = (property) => {
    // Determine if the new order should be ascending or descending
    const isAsc = orderBy === property && order === "asc";
    const newOrder = isAsc ? "desc" : "asc";
  
    // Update state with the new order and property
    setOrder(newOrder);
    setOrderBy(property);
  
    // Dispatch the new sort parameters
    dispatch({
      type: SORT_PARAMS,
      payload: { order: newOrder, orderBy: property },
    });
  
    // Reset pagination to the first page
    setPage(0);
    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });
  
    // Record the time the sort was clicked (optional)
    setSortClickedTime(new Date().toLocaleString());
  };
  

  const getSortIcon = (orderByValue) => {
    if (orderBy === orderByValue) {
      return order === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  // const sortedList = useMemo(() => {
  //   if (orderBy) {
  //     return [...list].sort((a, b) => {
  //       if (orderBy === "CreatedDate") {
  //         const dateA = new Date(a[orderBy]).getTime();
  //         const dateB = new Date(b[orderBy]).getTime();

  //         if (order === "asc") {
  //           return dateA - dateB;
  //         } else {
  //           return dateB - dateA;
  //         }
  //       } else if (
  //         orderBy === "BrokerCount" ||
  //         orderBy === "LocationCount" ||
  //         orderBy === "BillingPeriod"
  //       ) {
  //         const valueA = a[orderBy];
  //         const valueB = b[orderBy];

  //         if (order === "asc") {
  //           return valueA - valueB; // Ascending order
  //         } else {
  //           return valueB - valueA; // Descending order
  //         }
  //       } else if (orderBy === "Active") {
  //         const valueA = a[orderBy];
  //         const valueB = b[orderBy];
  //         if (order === "asc") {
  //           return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
  //         } else {
  //           return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
  //         }
  //       } else {
  //         const valueA = a[orderBy].toLowerCase();
  //         const valueB = b[orderBy].toLowerCase();

  //         if (order === "asc") {
  //           return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
  //         } else {
  //           return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
  //         }
  //       }
  //     });
  //   }
  //   return list;
  // }, [list, orderBy, order]);

  const handleChangeProject = (event) => {
    const {
      target: { value },
    } = event;

    setProjectName(value);

    setFilter((prevState) => ({
      ...prevState,
      projectId: value,
    }));

    if (value && value.length > 0) {
      getProjectFilterList(value.join(","));
    } else {
      getProjectFilterList();
    }
  };

  const clearProject = () => {
    setProjectName([]);
    setFilter((prevState) => ({ ...prevState, projectId: [] }));
    getProjectFilterList();
  };

  useEffect(() => {
    if (clearFiltervalue == true) {
      setPage(0);
    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });
      console.log("LOG 3")
      setFilter(filterInitial);
      setProjectName([]);
      getProjectFilterList();
    }
  }, [clearFiltervalue]);

  useEffect(() => {
    if (currentSort) {
      setOrder(currentSort.order);
      setOrderBy(currentSort.orderBy);
    }
  }, [currentSort]);

  const resetFilter = () => {
    setFilter(filterInitial);
    setProjectName([]);
    setSelectedProjects([]);
    setSearch("")
    setClearFilterValue(true);
  };
  // const clearFilterOpen = () => {
  //   setClearFlag(true);
  //   setClearFilterValue(false);
  // };
  const filterOpenFun = () => {
    setOpenFilter(!openFilter);
  };

  const filterClose = () => {
    setOpenFilter(false);
  };

  const applyFilterFun = () => {
    // getProjectFilterList();
    setOpenFilter(false);
    setApplyFilterFlag(true);
  };
  const submitFilter = () => {

    setPage(0);
    dispatch({
      type: PAGE_OFFSET,
      payload: 0,
    });

    setOpenFilter(false);
    setApplyFilterFlag(true);
    // setSelectedProjects([]);
    setClearFilterValue(false);
    getProjectFilterList("",0);
  };
  const handlePageChange = (e, value) => {
    setPage(value - 1);
    dispatch({
      type: PAGE_OFFSET,
      payload: value - 1,
    });
    // getProjectList(value - 1);
    getProjectFilterList("",value - 1);
  };
  useEffect(() => {
    dispatch(getAllCustomersList());
    dispatch(getAllProjectsList());
  }, []);

  // Filter Save Functionality

  const localStorageFilter = (value) => {
    if (value) {
      if (selectedProjects && selectedProjects.length > 0) {
        localStorage.setItem(
          "PROJECT_PAGE_SEARCH",
          enCryptFun(JSON.stringify(selectedProjects))
        );
      }

      if (applyFilterFlag) {
        localStorage.setItem(
          "PROJECT_PAGE_FILTER",
          enCryptFun(JSON.stringify(filter))
        );
      }

      dispatch({
        type: PAGE_OFFSET,
        payload: page,
      });

    } else {
      localStorage.removeItem("PROJECT_PAGE_FILTER", "");
      localStorage.removeItem("PROJECT_PAGE_SEARCH", "");
    }
  };

  useEffect(() => {
    if (localStorage.getItem("PROJECT_PAGE_BACKBUTTON_CLICK")) {
      const PROJECT_PAGE_SEARCH = localStorage.getItem("PROJECT_PAGE_SEARCH");
      const PROJECT_PAGE_FILTER = localStorage.getItem("PROJECT_PAGE_FILTER");

      var PROJECT_PAGE_FILTER_DEC = "";
      var PROJECT_PAGE_SEARCH_DEC = "";

      if (PROJECT_PAGE_FILTER) {
        const PROJECT_PAGE_FILTER_DEC_FILTER = deCryptFun(PROJECT_PAGE_FILTER);
        PROJECT_PAGE_FILTER_DEC = PROJECT_PAGE_FILTER_DEC_FILTER
          ? JSON.parse(PROJECT_PAGE_FILTER_DEC_FILTER)
          : "";
      }

      if (PROJECT_PAGE_SEARCH) {
        const PROJECT_PAGE_SEARCH_DEC_FILTER = deCryptFun(PROJECT_PAGE_SEARCH);
        PROJECT_PAGE_SEARCH_DEC = PROJECT_PAGE_SEARCH_DEC_FILTER
          ? JSON.parse(PROJECT_PAGE_SEARCH_DEC_FILTER)
          : "";
      }

      if (PROJECT_PAGE_SEARCH_DEC && PROJECT_PAGE_SEARCH_DEC.length > 0) {
        setSelectedProjects(PROJECT_PAGE_SEARCH_DEC);
      }

      if (PROJECT_PAGE_FILTER_DEC) {
        setFilter(PROJECT_PAGE_FILTER_DEC);
        setApplyFilterFlag(true);
      }

      localStorage.removeItem("PROJECT_PAGE_FILTER", "");
      localStorage.removeItem("PROJECT_PAGE_SEARCH", "");
      localStorage.removeItem("PROJECT_PAGE_BACKBUTTON_CLICK", "");
      setBackButtonFilter(true);
    } else {
      localStorage.removeItem("PROJECT_PAGE_FILTER", "");
      localStorage.removeItem("PROJECT_PAGE_SEARCH", "");
      localStorage.removeItem("PROJECT_PAGE_BACKBUTTON_CLICK", "");
      getProjectFilterList();
      setBackButtonFilter(false);
    }
  }, []);

  useEffect(() => {
    console.log("LOG 1")
    if (backButtonFilter) {
      let idsString = "";
      if (selectedProjects && selectedProjects.length > 0) {
        idsString = selectedProjects.map((item) => item.ProjectId).join(",");
      }
      getProjectFilterList(idsString,page);

      setBackButtonFilter(false);
    }
  }, [backButtonFilter]);

  useEffect(() => {

    if (sortClickedTime) {

    getProjectFilterList();
    
    }
  }, [sortClickedTime]);

  useEffect(() => {
    if (currentPage) {
      setPage(currentPage);
    }
  }, [currentPage]);



  // useEffect(() => {
  //   if(!localStorage.getItem("PROJECT_PAGE_BACKBUTTON_CLICK")){
  //     getProjectFilterList();
  //   }
  // }, [page]);

  return (
    <>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide= {'2'}/>

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar title="Project Management" backFlag={false} backRoute="" />

          <Box className="bg-box user-log">
            <Grid container>
              <Grid xs={5} md={5}>
                <Autocomplete
                  multiple
                  id="checkboxes-tags-demo"
                  // options={projectList}
                  options={projectList.sort((a, b) => {
                    const nameA = `${a.Name}`;
                    const nameB = `${b.Name}`;
                
                    // Step 1: Compare by first letter alphabetically (case-insensitive)
                    const firstCharA = nameA[0].toLowerCase();
                    const firstCharB = nameB[0].toLowerCase();
                
                    if (firstCharA !== firstCharB) {
                      return firstCharA.localeCompare(firstCharB); // Alphabetical order by first letter
                    }
                
                    // Step 2: If the first letters are the same, prioritize uppercase over lowercase
                    const isUpperCaseA = nameA[0] === nameA[0].toUpperCase();
                    const isUpperCaseB = nameB[0] === nameB[0].toUpperCase();
                
                    if (isUpperCaseA !== isUpperCaseB) {
                      return isUpperCaseA ? -1 : 1; // Uppercase comes before lowercase
                    }
                
                    // Step 3: If both are the same case, sort alphabetically
                    return nameA.localeCompare(nameB);
                  })}
                  disableCloseOnSelect
                  limitTags={1}
                  popupIcon={<KeyboardArrowDownIcon />}
                  getOptionLabel={(option) => option.Name}
                  filterOptions={(options, { inputValue }) => {
                    if (inputValue.trim() === "") {
                      return options;
                    }
                    return options.filter((option) =>
                      option.Name.toLowerCase().includes(
                        inputValue.toLowerCase()
                      )
                    );
                  }}
                  onChange={handleSearchOnChange}
                  value={selectedProjects}
                  renderTags={() => null}
                  renderOption={(props, option, { selected }) => {
                    const isSelected = selectedProjects.some(
                      (project) => project.ProjectId === option.ProjectId
                    );

                    return (
                      <li {...props} key={option.ProjectId}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={isSelected}
                          onChange={() =>
                            handleSearchCheckboxOnChange(option, isSelected)
                          }
                        />
                        <span className="select-option-text">
                          {option.Name}
                        </span>
                      </li>
                    );
                  }}
                  sx={{
                    width: { xs: "100%", md: 300 },
                    minWidth: { xs: "230px", md: "auto" },
                    height: 40,
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Search Projects"
                    />
                  )}
                />

                <div style={{ marginTop: 5 }}>
                  {selectedProjects.map((option) => (
                    <Chip
                      key={option.ProjectId}
                      label={option.Name}
                      onDelete={() => {
                        handleSearchDeleteOnChange(option.ProjectId);
                      }}
                      style={{ margin: 5 }}
                    />
                  ))}
                </div>
              </Grid>
              <Grid sx={{ mt: "auto", mb: "auto" }} xs={12} md={7}>
                <Stack
                  sx={{ float: { xs: "left", md: "right" } }}
                  direction={{ xs: "column", sm: "row", md: "row" }}
                  spacing={1}
                  alignItems={{ xs: "baseline", sm: "center", md: "center" }}
                >
                  {filter &&
                  ((selectedProjects && selectedProjects.length > 0) ||
                    (applyFilterFlag &&
                      (filter.projectId.length > 0 ||
                        filter.customerId.length > 0 ||
                        typeof filter.customerActive === "boolean" ||
                        typeof filter.active === "boolean" ||
                        filter.noOfBroker ||
                        filter.noOfLocation ||
                        filter.billingPeriod))) ? (
                    <Button
                      startIcon={
                        <span class="material-symbols-outlined">close</span>
                      }
                      className="clear-btn"
                      variant="contained"
                      onClick={resetFilter}
                    >
                      Clear Filter
                    </Button>
                  ) : (
                    ""
                  )}

                  <Stack
                    className="filter"
                    sx={{ float: "right" }}
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    onClick={filterOpenFun}
                  >
                    <span class="material-symbols-outlined">filter_list</span>
                    <Typography>Filter</Typography>
                  </Stack>
                  <Link
                    onClick={() => localStorageFilter(true)}
                    to={{
                      pathname: ADD_PROJECT,
                    }}
                  >
                    <Button
                      startIcon={
                        <span class="material-symbols-outlined">add</span>
                      }
                      className="primary-btn"
                      variant="contained"
                      color="success"
                    >
                      New Project
                    </Button>
                  </Link>
                </Stack>
              </Grid>
            </Grid>
            <Grid sx={{ mt: 2 }} container>
              <Grid xs={12} md={12}>
                <TableContainer
                  sx={{
                    boxShadow: "none",
                    maxHeight: { xs: 440, md: 440, lg: 400, xl: 527 },
                  }}
                  component={Paper}
                >
                  <Table
                    sx={{ minWidth: 650 }}
                    stickyHeader
                    aria-label="sticky table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ minWidth: { xs: "100px", md: "200px" } }}
                        >
                          <TableSortLabel
                            active={orderBy === "Name"}
                            direction={orderBy === "Name" ? order : "asc"}
                            onClick={() => handleSortRequest("Name")}
                            IconComponent={() => getSortIcon("Name")}
                            style={
                              orderBy === "Name" ? { color: "#007fff" } : {}
                            }
                          >
                            Project
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "CustomerName"}
                            direction={
                              orderBy === "CustomerName" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("CustomerName")}
                            IconComponent={() => getSortIcon("CustomerName")}
                            style={
                              orderBy === "CustomerName" ? { color: "#007fff" } : {}
                            }
                          >
                            Customer
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "BillingPeriod"}
                            direction={
                              orderBy === "BillingPeriod" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("BillingPeriod")}
                            IconComponent={() => getSortIcon("BillingPeriod")}
                            style={
                              orderBy === "BillingPeriod" ? { color: "#007fff" } : {}
                            }
                          >
                            Billing Period (in days)
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "LocationCount"}
                            direction={
                              orderBy === "LocationCount" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("LocationCount")}
                            IconComponent={() => getSortIcon("LocationCount")}
                            style={
                              orderBy === "LocationCount" ? { color: "#007fff" } : {}
                            }
                          >
                            No of Locations
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "BrokerCount"}
                            direction={
                              orderBy === "BrokerCount" ? order : "asc"
                            }
                            onClick={() => handleSortRequest("BrokerCount")}
                            IconComponent={() => getSortIcon("BrokerCount")}
                            style={
                              orderBy === "BrokerCount" ? { color: "#007fff" } : {}
                            }
                          >
                            No of Brokers
                          </TableSortLabel>
                        </TableCell>
                        <TableCell>
                          <TableSortLabel
                            active={orderBy === "Active"}
                            direction={orderBy === "Active" ? order : "asc"}
                            onClick={() => handleSortRequest("Active")}
                            IconComponent={() => getSortIcon("Active")}
                            style={
                              orderBy === "Active" ? { color: "#007fff" } : {}
                            }
                          >
                            Status
                          </TableSortLabel>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {loading && <CustomPageLoading />}
                    <TableBody>
                    {list &&
  list
    // .sort((a, b) => {
    //   const nameA = a.Name;
    //   const nameB = b.Name;

    //   // Step 1: Compare by first letter alphabetically (case-insensitive)
    //   const firstCharA = nameA[0].toLowerCase();
    //   const firstCharB = nameB[0].toLowerCase();

    //   if (firstCharA !== firstCharB) {
    //     return firstCharA.localeCompare(firstCharB); // Alphabetical order by first letter
    //   }

    //   // Step 2: If the first letters are the same, prioritize uppercase over lowercase
    //   const isUpperCaseA = nameA[0] === nameA[0].toUpperCase();
    //   const isUpperCaseB = nameB[0] === nameB[0].toUpperCase();

    //   if (isUpperCaseA !== isUpperCaseB) {
    //     return isUpperCaseA ? -1 : 1; // Uppercase comes before lowercase
    //   }

    //   // Step 3: If both are the same case, sort alphabetically
    //   return nameA.localeCompare(nameB);
    // })
    .map((r) => {
      const {
        ProjectId,
        Name,
        CustomerName,
        BillingPeriod,
        BrokerCount,
        LocationCount,
        Active,
      } = r;

      return (
                            <TableRow
                              component={Link}
                              to={{
                                pathname: `/project-details/${ProjectId}`,
                                state: { id: ProjectId },
                              }}
                              key={ProjectId}
                              onClick={() => {
                                localStorage.removeItem("DASHBOARD_NAVI");
                                localStorageFilter(true);
                              }}
                            >
                              <TableCell
                                sx={{
                                  maxWidth: "300px",
                                  lineBreak: "anywhere",
                                }}
                                scope="row"
                              >
                                {Name}
                              </TableCell>
                              <TableCell
                                sx={{
                                  maxWidth: "300px",
                                  lineBreak: "anywhere",
                                }}
                              >
                                {CustomerName}
                              </TableCell>
                              <TableCell>
                                {BillingPeriod ? BillingPeriod : 0} Days{" "}
                              </TableCell>
                              <TableCell>
                                {formatNumber(LocationCount)}
                              </TableCell>
                              <TableCell>{formatNumber(BrokerCount)}</TableCell>
                              <TableCell sx={{ minWidth: "150px" }}>
                                <span
                                  className={
                                    Active == 1 ? "active-btn" : "inactive-btn"
                                  }
                                >
                                  {Active == 1 ? "Active" : "Inactive"}
                                </span>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                  <br />
                </TableContainer>
                {!loading && total > 0 && (
                  <Pagination
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      mt: "15px",
                    }}
                    shape="rounded"
                    count={total}
                    page={page + 1}
                    // hidePrevButton
                    // hideNextButton
                    renderItem={(item) => (
                      <PaginationItem
                        components={{
                          previous: () => (
                            <Icon className="material-symbols-outlined">
                              keyboard_backspace
                            </Icon>
                          ),
                          next: () => (
                            <Icon className="material-symbols-outlined">
                              east
                            </Icon>
                          ),
                        }}
                        {...item}
                      />
                    )}
                    onChange={handlePageChange}
                  />
                )}
                {!loading && list && list.length == 0 ? (
                  <NoRecordFound />
                ) : (
                  <></>
                )}
                {openFilter && (
                  <ProjectFilter
                    open={openFilter}
                    handleClose={filterClose}
                    filter={filter}
                    setFilter={setFilter}
                    filterInitial={filterInitial}
                    submitFilter={submitFilter}
                    customerNameList={projectName}
                  />
                )}
                {clearFlag && (
                  <UserClearFilter
                    open={clearFlag}
                    clearFiltervalue={clearFiltervalue}
                    setClearFilterValue={setClearFilterValue}
                    resetFilter={resetFilter}
                  />
                )}
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Projectindex;
